import type {ReactNode} from 'react';
import type {Media} from '../../model';

// The hero ships as two designs: a pinned hero the page scrolls over like a
// curtain, and a plain hero that scrolls away with the page.
export enum HeroMode {
  PinnedCurtain = 'pinned-curtain',
  Static = 'static',
}

export enum HeroSize {
  Masthead = 'masthead',
  Full = 'full',
  Viewport = 'viewport',
  Compact = 'compact',
}

// What a hero renders when nothing tells it otherwise. A page that wants the other
// design passes `mode`/`size` — from its own config today, from the CMS section once
// the backend carries it.
export const DEFAULT_HERO_MODE = HeroMode.Static;
export const DEFAULT_HERO_SIZE = HeroSize.Masthead;

export type HeroSectionMedia = Media;

export interface HeroContentProps {
  media: HeroSectionMedia;
  mobileMedia?: HeroSectionMedia;
  title?: string;
  actions?: ReactNode;
}

export interface HeroShellProps extends HeroContentProps {
  size: HeroSize;
  // The pinned hero floats the header over itself. Only true when the hero is the
  // first thing on the page: anywhere else a transparent fixed header would sit over
  // whatever section came before it.
  headerOverlay?: boolean;
}

export interface HeroSectionProps extends HeroContentProps {
  mode?: HeroMode;
  size?: HeroSize;
  headerOverlay?: boolean;
}
